module.exports = __webpack_public_path__ + "static/media/Naviguard-BrandMark.af96ac7e.png";